import { render, staticRenderFns } from "./ExportPayments.vue?vue&type=template&id=87a1924e"
import script from "./ExportPayments.vue?vue&type=script&lang=js"
export * from "./ExportPayments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports